import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchReclamationTransporteur } from 'store/reclamation/reclamationsActions';
import { fetchReclamationInfosLogistique } from 'store/reclamation/detailsActions';
import { fetchTransporteurs } from 'store/transporteur/transporteurActions';
import DemandeRetourMarchandisesContent from './DemandeRetourMarchandisesContent';
import withLoader from 'components/Shared/withLoader';

const DemandeRetourMarchandisesContentWithLoader = withLoader(DemandeRetourMarchandisesContent);

class DemandeRetourMarchandisesContentContainer extends React.Component {


    async componentDidMount() {
        await this.props.fetchTransporteurs();
        await this.props.fetchReclamationTransporteur(this.props.reclamationId);
        await this.props.fetchReclamationInfosLogistique(this.props.reclamationId);
    }

    render() {
        const { transporteurId, memoDefaut, isLoading, onChange, action, transporteurs, colis, depotDepart, nomLivraison, livraisonAdresse } = this.props;

        return (
            <DemandeRetourMarchandisesContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                transporteurId={transporteurId}
                memoDefaut={memoDefaut}
                colis={colis}
                transporteurs={transporteurs}
                depotDepart={depotDepart}
                nomLivraison={nomLivraison}
                livraisonAdresse={livraisonAdresse}
            />
        );
    }
}

DemandeRetourMarchandisesContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {

    let transporteur = state.reclamation.reclamations.transporteurs.items.find(x => x.reclamationId === props.reclamationId);
    let isLoading = state.reclamation.reclamations.transporteurs.isLoading || state.transporteur.transporteurs.isLoading || state.reclamation.details.isInfosLogistiqueLoading;

    let depotDepart = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.depotDepart : '';

    let nomLivraison = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.nomLivraison : '';
    let livraisonAdresse1 = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.livraisonAdresse1 : '';
    let livraisonAdresse2 = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.livraisonAdresse2 : '';
    let livraisonCodePostal = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.livraisonCodePostal : '';
    let livraisonVille = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.livraisonVille : '';

    let livraisonAdresse = livraisonAdresse1 + '\n' + livraisonAdresse2 + '\n' + livraisonCodePostal + ' ' + livraisonVille;

    return {
        isLoading: isLoading,
        transporteurId: (transporteur && transporteur.transporteurId !== -1) ? transporteur.transporteurId : '',
        transporteurs: state.transporteur.transporteurs.items,
        colis: transporteur ? transporteur.colis : [],
        depotDepart: depotDepart,
        nomLivraison: nomLivraison,
        livraisonAdresse: livraisonAdresse,
    };
};

const mapDispatchToProps = {
    fetchTransporteurs,
    fetchReclamationTransporteur,
    fetchReclamationInfosLogistique
};

export default connect(mapStateToProps, mapDispatchToProps)(DemandeRetourMarchandisesContentContainer);